// Package imports:
import React from 'react';
import cx from 'classnames';
// Component imports:
import AdRotator from '../../components/Ad/AdRotator';

interface IProps {
    hasAds?: 'main' | 'market' | undefined,
    title: string | React.HTMLAttributes<HTMLDivElement> | JSX.Element,
    description?: JSX.Element,
    actions?: JSX.Element,
    rightSide?: JSX.Element,
    textAlign?: 'left' | 'right' | 'center' | 'left-to-center',
    noSpaceBetween? : boolean,
}

const HeadSection: React.FC<IProps> = ({
    hasAds,
    title,
    description,
    actions,
    rightSide,
    textAlign = 'left',
    noSpaceBetween = false
}) => {
    return (
        <div className="section KCL_head-section">
            {/* ADS SECTION */}
            {
                hasAds ?
                    hasAds === 'main'
                    ? (
                        window.matchMedia('(max-width: 1023px)').matches
                            ? <AdRotator location="Head400x80" />
                            : <AdRotator location="Head1360x180" />
                    )
                    : (
                        window.matchMedia('(max-width: 1023px)').matches
                            ? <AdRotator location="MarketHead400x80" />
                            : <AdRotator location="MarketHead1018x360" />
                    )
                : null
            }

            {/* HEADER SECTION */}
            <div className={cx(
                'section__head--title',
                `${textAlign}-align`,
                {
                    'noAds': !hasAds ,
                    'marginBottom30px' : !description,
                    'noSpaceBetween' : noSpaceBetween
                }
            )}>
                {
                    (typeof(title) !== 'string')
                    ? (<>{title}</>)
                    : (<h1 >{title}</h1>)
                }
            </div>
            {/* SUMMARY SECTION */}
            {
                description && (
                    <div className={cx('section__head--content', `${textAlign}-align`)}>
                        <div className="content--main">
                            {description}
                            {
                                actions && (
                                    <div className="section__head--actions">
                                        {actions}
                                    </div>
                                )
                            }
                        </div>
                        {
                            rightSide && (
                                <div className="content--right">
                                    {rightSide}
                                </div>
                            )
                        }
                    </div>
                )
            }
        </div>
    );
}

export default HeadSection;